import { render } from "./tasks-view.vue?vue&type=template&id=78060830"
import script from "./tasks-view.vue?vue&type=script&lang=js"
export * from "./tasks-view.vue?vue&type=script&lang=js"

import "./tasks-view.vue?vue&type=style&index=0&id=78060830&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__